module.exports = __webpack_public_path__ + "media/images/flags/1x1/nzl-15efcab8fd0ce9437bad9bd2ef29923a.svg";